/**
 * 描述：共享稿库左侧
 * 日期：2017-8-21
 * 作者: Bai.Zhiming
 */
'use strict';
angular.module('myResourcesLeftModule', []).directive('myResourcesLeft', [
    '$state',
    '$q',
    '$timeout',
    'resourceCenterService',
    '$stateParams',
    'trsHttpService',
    'myResourcesService',
    function($state, $q, $timeout, resourceCenterService, $stateParams, trsHttpService, myResourcesService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            templateUrl: './networkResource/myResources/left/left_tpl.html',
            link: function(scope, $attr, $elem) {
                initStatus();
                initData();
                var promise;

                /**
                 * [searchNode description] 搜索节点
                 * @param   {[type]}  $viewValue  [$viewValue description]
                 * @return  {[type]}              [return description]
                 */
                scope.searchNode = function($viewValue) {
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    scope.isVisable = false;
                    scope.typeaheadWidth = 0;
                    promise = $timeout(function() {
                        if ($viewValue !== '' && !angular.isObject($viewValue)) {
                            var params = {
                                typeid: 'zyzx',
                                serviceid: 'subscript',
                                modelid: 'getAllGroups',
                                keyword: $viewValue,
                            };
                            return trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                                if ($viewValue) {
                                    scope.isVisable = true;
                                }
                                scope.data.searchNodeDataLen = data.length;
                                for (var i = 0; i < data.content.length; i++) {
                                    var name = data.content[i].title;
                                    data.content[i].allName = name;
                                    data.content[i].name = (function(name) {
                                        var nameArray = name.split('#');
                                        return nameArray[nameArray.length - 1];
                                    })(name);
                                }
                                $timeout(function() {
                                    scope.typeaheadWidth = $('.searchword')
                                        .find('.resouce_center_typeahead')
                                        .prop('scrollWidth');
                                }, 500);
                                return data.content;
                            });
                        }
                    }, 500);
                    return promise;
                };
                scope.$watch('status.suggestion', function(newV, oldV) {
                    if (angular.isObject(newV)) {
                        $timeout(function() {
                            scope.selectedChildren('', newV);
                        }, 1000);
                        scope.status.suggestion = '';
                    }
                });

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        childrenExpanded: true,
                    };
                    scope.data = {};
                }

                /**
                 * [initLocation description] 初始化定位
                 * @return {[type]} [description]
                 */
                function initLocation() {
                    if ($state.current.name.indexOf('front.networksource.myresources') < 0) {
                        if (resourceCenterService.hasNavigationMemory('myresources', scope)) {
                            // resourceCenterService.navigationMemory("myresources");
                            selectedModule();
                            $timeout(function() {
                                scope.status.selectedModule = $state.current.name.split('.')[3];
                                scope.status.curGroupId = $stateParams.groupid;
                            }, 1000);
                        } else {
                            selectedModule();
                        }
                    } else {
                        $timeout(function() {
                            scope.status.selectedModule = $state.current.name.split('.')[3];
                            scope.status.curGroupId = $stateParams.groupid;
                        }, 1000);
                    }
                }

                /**
                 * [selectedModule description] 选择模块
                 * @param {moduleName} [varname] [description] 模块名称
                 * @return {[type]} [description]
                 */
                function selectedModule() {
                    var moduleName = 'subscriptionfolder';
                    var urlName = 'front.networksource.myresources.' + moduleName;
                    scope.status.selectedModule = moduleName;
                    $state.go(urlName, '', { reload: urlName });
                }
                scope.selectedModule = selectedModule;

                /**
                 * [expandChildren description] 展开子节点
                 * @param   {[type]}  $event  [$event description]
                 * @return  {[type]}          [return description]
                 */
                scope.expandChildren = function($event) {
                    $event.stopPropagation();
                    scope.status.childrenExpanded = !scope.status.childrenExpanded;
                };

                /**
                 * [selectedChildren description] 选择订阅夹
                 * @param   {[type]}  $event  [$event description]
                 * @param   {[type]}  item    [item description]
                 * @return  {[type]}          [return description]
                 */
                scope.selectedChildren = function($event, item) {
                    if ($event !== '') {
                        $event.stopPropagation();
                    }
                    scope.status.curGroupId = item.id;
                    var moduleName = 'subscriptionfolderson';
                    var urlName = 'front.networksource.myresources.subscriptionfolderson';
                    scope.status.selectedModule = moduleName;
                    resourceCenterService.go(urlName, { groupid: item.id });
                };

                /**
                 * [showChildren description] 查询订阅夹
                 * @return {[type]} [description]
                 */
                function showChildren() {
                    let deffer = $q.defer();
                    if (!scope.status.subsctibeList) {
                        var params = {
                            typeid: 'zyzx',
                            serviceid: 'subscript',
                            modelid: 'getAllGroups',
                        };
                        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                            scope.status.subsctibeList = data.content;
                            deffer.resolve();
                        });
                    }
                    return deffer.promise;
                }

                /**
                 * [setCommon description] 设置常用
                 * @param   {[type]}  folder  [folder description]
                 * @param   {[type]}  $event  [$event description]
                 * @return  {[type]}          [return description]
                 */
                scope.setCommon = function(folder, $event) {
                    $event.stopPropagation();
                    myResourcesService
                        .setCommonMyResource(folder.id, folder.isCommon === 1 ? 0 : 1)
                        .then(function() {
                            return myResourcesService.setCommonEditingCenter(folder.id, folder.title, folder.isCommon === 1 ? 0 : 1);
                        })
                        .then(function() {
                            resourceCenterService.go($state.current.name, {});
                            folder.isCommon = folder.isCommon === 1 ? 0 : 1;
                        });
                };

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    showChildren().then(() => {
                        initLocation();
                    });
                }
            },
        };
    },
]);
